const NotificationDenied = ({ className, style }: { className?: string; style?: any }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <rect width="48" height="48" rx="16" fill="#FFF1F1" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 15C19.0294 15 15 19.0294 15 24C15 28.9706 19.0294 33 24 33C28.9706 33 33 28.9706 33 24C33 19.0294 28.9706 15 24 15ZM13 24C13 17.9249 17.9249 13 24 13C30.0751 13 35 17.9249 35 24C35 30.0751 30.0751 35 24 35C17.9249 35 13 30.0751 13 24Z"
        fill="#942020"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.7071 20.2929C28.0976 20.6834 28.0976 21.3166 27.7071 21.7071L21.7071 27.7071C21.3166 28.0976 20.6834 28.0976 20.2929 27.7071C19.9024 27.3166 19.9024 26.6834 20.2929 26.2929L26.2929 20.2929C26.6834 19.9024 27.3166 19.9024 27.7071 20.2929Z"
        fill="#942020"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2929 20.2929C20.6834 19.9024 21.3166 19.9024 21.7071 20.2929L27.7071 26.2929C28.0976 26.6834 28.0976 27.3166 27.7071 27.7071C27.3166 28.0976 26.6834 28.0976 26.2929 27.7071L20.2929 21.7071C19.9024 21.3166 19.9024 20.6834 20.2929 20.2929Z"
        fill="#942020"
      />
    </svg>
  );
};

export default NotificationDenied;
